<template>
  <div>
    <v-container fluid class="">
      <v-row class="mb-5">
        <v-col cols="6" sm="12" md="4" lg="4">
          <v-text-field
            v-model="filter.SearchTerm"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            solo
            hide-details
          />
        </v-col>
      </v-row>

      <template>
        <v-card :loading="loading">
          <v-card-title>
            <div v-for="(folder, i) in pathFromJob" :key="folder.name">
              <span v-if="i !== 0" class="mx-1"><small>/</small></span>
              <v-btn depressed x-small @click="openFolder(folder.id)">
                <small>{{ folder.name }}</small>
              </v-btn>
            </div>
          </v-card-title>
          <v-skeleton-loader
            v-if="isLoading"
            class="mx-auto"
            type="table"
          ></v-skeleton-loader>
          <v-data-table
            v-else
            :headers="activeHeaders"
            :items="mixedItems"
            class="elevation-1"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            :hide-default-footer="true"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
            }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-row class="mx-1">
                      <v-btn rounded class="content-ma-0 mt-2 mr-2" v-on="on" x-small>
                        <v-icon small>menu</v-icon> Customize Columns
                      </v-btn>

                      <v-spacer />
                      
                      <v-btn
                        v-if="hasAccess('storage.add')"
                        @click="onAdd()"
                        class="mt-2 mr-2"
                        x-small
                      >
                        Upload File
                      </v-btn>

                      <v-btn
                        v-if="hasAccess('storage.add')"
                        @click="onAddFolder()"
                        class="mt-2"
                        x-small
                      >
                        New Folder
                      </v-btn>
                    </v-row>
                  </template>
                  <v-list dense>
                    <v-list-item dense :key="i" v-for="(header, i) in headers">
                      <v-list-item-title v-if="header.readonly">
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                          :disabled="true"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </template>

            <template v-slot:item.lastUpdated="{ item }">
              <v-chip @click="onEdit(item)" small>
                {{ item.lastUpdated | formatDatetime }}
              </v-chip>
            </template>

            <template v-slot:item.dateCreated="{ item }">
              <v-chip @click="onEdit(item)" small>
                {{ item.dateCreated | formatDatetime }}
              </v-chip>
            </template>

            <template v-slot:item.categories="{ item }">
              <TagsChip :value="item.categories" />
            </template>

            <template v-slot:item.date="{ item }">
              <v-chip small @click="onEdit(item)">
                {{ item.date | formatDate }}
              </v-chip>
            </template>

            <template v-slot:item.userId="{ item }">
              <span @click="onEdit(item)">
                <UsersChip :value="item.taskUsers" />
              </span>
            </template>

            <template v-slot:item.size="{ item }">
              <div>
                <small v-if="!item.isFolder">
                  {{ item.size ? bytesToSize(item.size) : "" }}
                </small>
                <small v-else> {{ item.totalFiles }} File(s) </small>
              </div>
            </template>

            <template v-slot:item.status="{ item }">
              <span @click="onEdit(item)"
                ><TaskStatusChip :status="item.status"
              /></span>
            </template>

            <template v-slot:item.name="{ item }">
              <span
                @click="openFolder(item.id)"
                v-if="item.isFolder"
                style="cursor: pointer"
              >
                <v-icon>{{ item.icon }}</v-icon> {{ item.name }}
              </span>

              <span v-else>
                <v-icon>{{ item.icon }}</v-icon> {{ item.name }}
              </span>
            </template>

            <template v-slot:item.type="{ item }" @click="onEdit(item)">
              <span>
                {{ item.type }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon small class="content-ma-0" v-on="on">
                    <v-icon small>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    @click="onDownload(item)"
                    v-show="
                      hasAccess('storage.view') &&
                      !item.isFolder &&
                      item.canDownload
                    "
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-download</v-icon>Download
                    </v-list-item-title>
                  </v-list-item>



                  <v-list-item
                    @click="onEdit(item)"
                    v-show="hasAccess('storage.edit') && item.canEdit"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-pencil</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onDelete(item)"
                    v-show="hasAccess('storage.delete') && item.canDelete"
                  >
                    <v-list-item-title>
                      <v-icon small left>delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-container>

    <file-form
      :show="showForm"
      :clientId="clientId"
      :item="selectedItem"
      :path="path"
      @onClosed="clearAdd()"
      @onSucceded="refresh()"
    ></file-form>

    <folder-form
      :show="showFormFolder"
      :clientId="clientId"
      :item="selectedItem"
      :path="path"
      @onClosed="clearAddFolder()"
      @onSucceded="refresh()"
    ></folder-form>

    <delete-dialog
      :show="showDelete"
      :item="selectedItem"
      @onClosed="clearDelete()"
      @onSucceded="refresh()"
    />

    <delete-folder-dialog
      :show="showDeleteFolder"
      :item="selectedItem"
      @onClosed="clearDelete()"
      @onSucceded="refresh()"
    />
  </div>
</template>

<script>
import DeleteDialog from "../Storage/_Delete";
import DeleteFolderDialog from "../Storage/_DeleteFolder";
import FileForm from "../Storage/_Form";
import FolderForm from "../Storage/_FormFolder";
import { mapActions, mapState, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import TaskStatusChip from "src/components/TaskStatusChip";
import UsersChip from "components/UsersChip";
import _ from "lodash";
import { getStorage, setStorage } from "src/utils/helpers";
import TagsChip from "components/TagsChip";

const SETTING_LIST_KEY = "storage-columns-jobs";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
    width: "5%",
  },
  { text: "Name", value: "name", sortable: true, active: true },
  { text: "Size", value: "size", sortable: true, active: true },
  { text: "Type", value: "type", sortable: true, active: true },
  { text: "Notes", value: "notes", active: true },
  { text: "Created By", value: "createdBy", active: false },
  {
    text: "Created On",
    value: "dateCreated",
    sortable: true,
    active: false,
  },
  { text: "Updated By", value: "updatedBy", active: true },
  {
    text: "Updated On",
    value: "lastUpdated",
    sortable: true,
    active: true,
  },
];
export default {
  mixins: [formatterMixin],
  props: {
    clientId: Number,
    hideTitle: Boolean,
    item: Object,
    show: Boolean,
  },

  components: {
    FileForm,
    DeleteDialog,
    TaskStatusChip,
    UsersChip,
    FolderForm,
    TagsChip,
    DeleteFolderDialog,
  },
  data: () => ({
    isEdit: false,
    valid: false,
    namespace: "Storage",
    page: "Files",

    folderId: null,

    tableOptions: {
      itemsPerPage: 1000,
    },
    users: [],

    filter: {
      SearchTerm: "",
      clientId: "",
      tags: [],
      folderId: null,
    },

    keyword: "",
    headers: defaultHeaders.map((item) => {
      let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
      let nowHeader = savedHeaders.filter(
        (saved) => saved.value === item.value
      );

      if (nowHeader) {
        nowHeader = nowHeader[0];
      }
      return {
        ...item,
        ...nowHeader,
      };
    }),

    showForm: false,
    showFormFolder: false,
    showDelete: false,
    showDeleteFolder: false,
    selectedItem: {},
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account.data,
      loading: (state) => state.file.loadingTable,
      totalItems: (state) => state.storage.metaData.totalEntries,
      path: (state) => state.storage.path,
    }),

    mixedItems() {
      return this.$store.getters["storage/getAll"];
    },

    pathFromJob() {
      const jobDepth = this.path.find((folder) => (folder.id === this.jobFolderId))?.depth || 0;
      return this.path.filter(folder => folder.depth >= jobDepth);
    },

    jobFolderId() {
      return this.item.folderId;
    },

    isLoading() {
      return this.loading && this.mixedItems.length == 0;
    },

    computedFilter() {
      let { clientId, SearchTerm, tags } = this.filter;
      let { sortBy, page, sortDesc, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 1000,
      };

      params.OrderBy =
        sortBy.length > 0 && sortBy && sortBy[0] ? sortBy[0] : null;

      if (params.OrderBy) {
        params.Ascending =
          sortDesc.length > 0 && sortDesc && sortDesc[0] ? false : true;
      } else {
        params.Ascending = false;
      }

      if (clientId) {
        params.clientId = clientId;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }

      if (this.folderId) {
        params.folderId = this.folderId;
      }

      if (tags && tags.length > 0) {
        params.tags = tags;
      }
      return params;
    },

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },

    tags() {
      return this.filter.tags;
    },
  },
  watch: {
    async show(showNew, showOld) {
      if (showNew !== showOld && showNew) {
        this.openFolder(this.jobFolderId);
      }
    },

    async folderId() {
      await this.refresh();
    },

    async jobFolderId() {
      await this.refresh();
    },

    tags() {
      this.taskSearch(this.filter);
    },

    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },
    tableOptions: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh(true);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.clientId) {
      this.filter.clientId = this.clientId;
    }
    // await this.loadFolders();
    await this.$store.dispatch("userGroup/getAll");
    this.openFolder(this.jobFolderId);
  },

  beforeDestroy() {
    if (this.clientId) {
      this.clearTableFilter();
    }
    clearInterval(this.timer);
    this.$store.dispatch("storage/clearData");
  },

  methods: {
    ...mapActions("storage", ["clearTableFilter", "applyTableFilter"]),

    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },

    ...mapActions({
      taskDelete: "storage/delete",
      taskSearch: "storage/search",
      downloadFile: "storage/download",
      getFolder: "storage/getFolder",
      // getJobRootFolderByCode: "storageFolder/getJobRootFolderByCode",
    }),

    refresh: _.debounce(async function () {
      this.refreshTable(true);
    }, 500),

    async refreshTable() {
      this.applyTableFilter({ ...this.computedFilter });
    },

    openFolder(folderId) {
      this.folderId = folderId;
    },

    onAdd() {
      this.showForm = true;
      this.selectedItem = {};
    },

    onAddFolder() {
      this.showFormFolder = true;
      this.selectedItem = {};
    },

    onEdit(item) {
      if (!this.hasAccess("task.edit")) {
        return false;
      }
      if (item.isFolder) {
        this.showFormFolder = true;
      } else {
        this.showForm = true;
      }
      this.selectedItem = item;
    },

    clearAdd() {
      this.showForm = false;
      this.selectedItem = {};
    },

    clearAddFolder() {
      this.showFormFolder = false;
      this.selectedItem = {};
    },

    clearDelete() {
      this.showDelete = false;
      this.showDeleteFolder = false;
      this.selectedItem = {};
    },

    onDelete(item) {
      if (item.isFolder) {
        this.showDeleteFolder = true;
      } else {
        this.showDelete = true;
      }
      this.selectedItem = item;
    },

    async onDownload(item) {
      await this.downloadFile(item);
    },
  },
};
</script>
